import { useEffect, useRef, useState } from "react";
import PageTitle from "../../../../components/partials/PageTitle"
import ReportFilter from "../CustomerReport/ReportFilter"
import { useSelector } from "react-redux";
import { getSavingsClaimReport } from "../../../../redux/slice/report/reportSlice";
import { useDispatch } from "react-redux";
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import { CSVLink } from "react-csv";
import { useReactToPrint } from "react-to-print";

const SavingsClaimReport = () => {

  const CCPdfRef = useRef();

    const [filterData, setFilterData] = useState();
    const [filteredItem, setFilteredItem] = useState(false);

    const dispatch = useDispatch()

    const { user } = useSelector((state) => state.auth);

    const {customerOverviewData} = useSelector((state) => state.report);

    const breadcrumb = {
        from: {
          title: "Savings Policy Report",
          link: "/admin/reports/savings-policy-report",
        },
        current: {
          title: "Savings Claim Report",
          link: null,
        },
    };

    const totalClaimAmount = customerOverviewData?.reduce((total, item) => {
      if (item?.claimStatus !== '0') {
        return total + (parseFloat(filterData?.claim_category === 'savings_claim' ? item?.claimAmountPayable : item?.claimAmountCover) || 0);
      }
      return total;
    }, 0);
    

    const generatePDF = useReactToPrint({
      content: () => CCPdfRef.current,
      documentTitle: "Savings Claim Report",
    });

    const processedData = customerOverviewData?.map(row => {
      const fullName = `${row.customerFirstName} ${row.customerLastName}`;
      const agent = `${row.agentFirstName} ${row.agentLastName}`;
      const statusValue = row.claimStatus;
      const claimValue = row.ClaimType;
      let statusLabel = "";
      let claimLabel = "";

      switch (statusValue) {
        case "0":
          statusLabel = "pending";
          break;
        case "1":
          statusLabel = "approved";
          break;
        default:
          statusLabel = "unknown";
      }

      switch (claimValue) {
        case "1":
          claimLabel = "Maturity";
          break;
        case "2":
          claimLabel = "Termination";
        break;
        case "3":
          claimLabel = "Partial Withdrawal";
        break;
        default:
        claimLabel = "unknown";
      }
  
      return { ...row, full_name: fullName, agent, statusLabel, claimLabel }; // Modify status property while keeping the rest
    }); 

    const headers = [
      { label: 'Claims Id', key: 'claimId' },
      { label: 'Customer Id', key: 'customerId' },
      { label: 'Customer Name', key: 'full_name' },
      { label: 'Policy', key: 'policy' },
      { label: 'Total Premium', key: 'totalPremium' },
      { label: 'Claims Amount', key: 'claimAmountCover' },
      { label: 'Status', key: 'statusLabel' },
      { label: 'Agent', key: 'agent' },
      { label: 'Office', key: 'officeName' },
    ];
    
    const headers1 = [
      { label: 'Claims Id', key: 'claimId' },
      { label: 'Customer Id', key: 'customerId' },
      { label: 'Customer Name', key: 'full_name' },
      { label: 'Policy', key: 'policy' },
      { label: 'Claim Type', key: 'claimLabel' },
      { label: 'Interest', key: 'interest' },
      { label: 'Claims Amount', key: 'claimAmountPayable' },
      { label: 'Status', key: 'statusLabel' },
      { label: 'Agent', key: 'agent' },
      { label: 'Office', key: 'officeName' },
    ];

    useEffect(() => {
      if (filteredItem) {
        if (filterData.office_id === '') {
          const updatedFilterData = {
            ...filterData,
            office_id: user?.user?.office_id
          };
          dispatch(getSavingsClaimReport(updatedFilterData));
        }else{
          dispatch(getSavingsClaimReport(filterData));
        }
      }
    }, [dispatch, filterData, filteredItem, user?.user?.office_id])

  return (
    <div>
        {/* page title */}
        <PageTitle title='Savings Claim Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
            <ReportFilter
                page={"savingsClaim"}
                setFilterData={setFilterData}
                setFilteredItem={setFilteredItem}
                filteredItem={filteredItem}
            />
          {customerOverviewData && (
                  <div className='row mb-3'>
                    <>
                      <div className='d-flex justify-content-end align-items-center'>
                        <div className=' d-flex align-items-center border '>
                          <span
                            className='bg-info me-2 text-white'
                            style={{ padding: "3px" }}
                          >
                            Export to
                          </span>
        
                          <span
                            href='#'
                            id='btnExport'
                            className='me-1 cursor-p'
                            title='Export to Pdf'
                            onClick={generatePDF}
                          >
                            <img
                              src={pdf}
                              alt='export-pdf'
                              style={{ height: "25px" }}
                            />
                          </span>
                          {customerOverviewData ? (
                            <CSVLink
                              data={processedData}
                              headers={filterData?.claim_category === 'savings_claim' ? headers1 : headers}
                              style={{ fontWeight: "bolder", cursor: "pointer" }}
                              filename='Savings Claim Report'
                            >
                              <span
                                href='#'
                                id='btnExport'
                                className='mr-1'
                                title='Export to Excel'
                              >
                                <img
                                  src={excel}
                                  alt='export-excel'
                                  style={{ height: "25px", marginRight: "5px" }}
                                />
                              </span>
                            </CSVLink>
                          ) : null}
                        </div>
                      </div>
                      <div className='table-responsive'>
                      <table
                  className="table table-centered table-striped nowrap w-100 no-footer"
                  ref={CCPdfRef}
                >
                  <thead>
                    <tr>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "100.8px" }}
                        aria-label="Email: activate to sort column ascending"
                      >
                        Claims Id
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "180.8px" }}
                        aria-label="Customer: activate to sort column ascending"
                      >
                        Customer Id
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "164.8px" }}
                        aria-label="Phone: activate to sort column ascending"
                      >
                        Customer Name
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "144.8px" }}
                        aria-label="Phone: activate to sort column ascending"
                      >
                        Policy
                      </th>
                      {filterData?.claim_category === 'savings_claim' && <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Claim Type
                      </th>}
                      {filterData?.claim_category === 'other_cover' && <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Total Premium
                      </th>}
                      {filterData?.claim_category === 'savings_claim' && <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Interest
                      </th>}
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Claims Amount
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Status
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Agent
                      </th>
                      <th
                        className="sorting"
                        tabIndex="0"
                        rowSpan="1"
                        colSpan="1"
                        style={{ width: "120.8px" }}
                        aria-label="Status: activate to sort column ascending"
                      >
                        Office
                      </th>
                    </tr>
                  </thead>
                  {customerOverviewData?.length ? (
                    <tbody>
                      {customerOverviewData?.map((item, i) => (
                        <tr key={i}>
                          <td className="text-dark">{item?.claimId}</td>
                          <td className="text-dark">{item?.customerId}</td>
                          <td className="table-user">
                            <span className="text-body fw-semibold">
                              {item?.customerFirstName} {item?.customerLastName}
                            </span>
                          </td>
                          <td className="table-user">{item?.policy}</td>
                          {filterData?.claim_category === 'savings_claim' && <td className="table-user">
                            <span className="">
                              {item?.ClaimType
                                ? item?.ClaimType === "1" && "Maturity"
                                : null}
                            </span>
                            <span className="">
                              {item?.ClaimType
                                ? item?.ClaimType === "2" && "Termination"
                                : null}
                            </span>
                            <span className="">
                              {item?.ClaimType
                                ? item?.ClaimType === "3" && "Partial Withdrawal"
                                : null}
                            </span>
                            <span className="">
                              {item?.ClaimType
                                ? item?.ClaimType === "4" && "Death Benefit"
                                : null}
                            </span>
                          </td>}
                          {filterData?.claim_category === 'other_cover' && <td className="table-user">{parseFloat(item?.totalPremium)?.toFixed(2)}</td>}
                          {filterData?.claim_category === 'savings_claim' && <td className="table-user">{item?.interest ? parseFloat(item?.interest)?.toFixed(2) : '-'}</td>}
                          <td className="table-user">{filterData?.claim_category === 'savings_claim' ? parseFloat(item?.claimAmountPayable)?.toFixed(2) : parseFloat(item?.claimAmountCover)?.toFixed(2)}</td>
                          <td className="table-user">
                            <span className="badge badge-warning-lighten">
                              {item?.claimStatus
                                ? item?.claimStatus === "0" && "Pending"
                                : null}
                            </span>
                            <span className="badge badge-success-lighten">
                              {item?.claimStatus
                                ? item?.claimStatus === "1" && "Approved"
                                : null}
                            </span>
                          </td>
                          <td className="table-user">
                            <span className="text-body fw-semibold">
                              {item?.agentFirstName} {item?.agentLastName}
                            </span>
                          </td>
                          <td className="table-user">{item?.officeName}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={filterData?.claim_category === 'savings_claim' ? "6" : "5"} className="text-end fw-bold">
                          Total Claim Amount:
                        </td>
                        <td className="fw-bold">{totalClaimAmount.toLocaleString()}</td>
                        <td colSpan="3"></td>
                      </tr>
                    </tbody>
                  ) : null}
                </table>
                        {customerOverviewData?.length < 1 ? (
                          <h5 className='alert alert-info'>No result found!</h5>
                        ) : null}
                      </div>
                    </>
                  </div>
                )}
        </div>
    </div>
  )
}

export default SavingsClaimReport